module.exports = __webpack_public_path__ + "img/image9.c2f9b05.webp";